import React, { useState } from 'react';
import { db } from '../db';
import { v4 as uuidv4 } from 'uuid';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import { Plus } from 'lucide-react';
import { SyncService } from '../services/SyncService';

const AddItem = ({ socket }) => {
  const [formData, setFormData] = useState({
    name: '',
    category: 'Divers',
    quantity: '1',
    estimated_price: ''
  });

  const categories = ['Divers', 'Fruits & Légumes', 'Produits Laitiers', 'Boucherie', 'Surgelés', 'Épicerie', 'Boissons', 'Hygiène'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) return;

    const householdId = localStorage.getItem('household_id');

    const newItem = {
      id: uuidv4(),
      ...formData,
      status: 'pending',
      updated_at: new Date().toISOString()
    };

    try {
      // 1. Ajout local dans Dexie
      await db.items.add(newItem);
      
      // 2. Reset du formulaire
      setFormData({ name: '', category: 'Divers', quantity: '1', estimated_price: '' });
      
      // 3. Pousser vers le serveur
      await SyncService.pushLocalChanges();

      // 4. SIGNAL TEMPS RÉEL : On prévient les autres membres du foyer
      if (socket && householdId) {
        socket.emit('send_update', householdId);
        console.log("⚡ Signal envoyé : Nouvel article ajouté !");
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout:", error);
    }
  };

  return (
    <Card className="border-0 shadow-sm rounded-4 mb-4">
      <Card.Body className="p-3">
        <Form onSubmit={handleSubmit}>
          <Row className="g-2">
            <Col xs={12} md={5}>
              <Form.Control 
                placeholder="Nom du produit..." 
                value={formData.name}
                onChange={e => setFormData({...formData, name: e.target.value})}
                className="bg-light border-0"
              />
            </Col>
            <Col xs={5} md={3}>
              <Form.Select 
                value={formData.category}
                onChange={e => setFormData({...formData, category: e.target.value})}
                className="bg-light border-0"
              >
                {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
              </Form.Select>
            </Col>
            <Col xs={4} md={2}>
              <Form.Control 
                placeholder="Qté" 
                value={formData.quantity}
                onChange={e => setFormData({...formData, quantity: e.target.value})}
                className="bg-light border-0"
              />
            </Col>
            <Col xs={3} md={2}>
              <Button variant="success" type="submit" className="w-100 rounded-3 shadow-sm">
                <Plus size={20} />
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AddItem;